export const generalSettings = {
  platformName: 'MeetingHub AI',
  baseUrl: 'https://admin.meetinghub.ai',
  supportEmail: 'support@meetinghub.ai',
  defaultLocale: { value: 'en', label: 'English' },
  defaultTimezone: { value: 'Asia/Muscat', label: 'Asia/Muscat' },
  dateFormat: 'YYYY-MM-DD',
  timeFormat: '24h',
  maintenanceWindows: [
    {
      id: 'mw-1',
      startAt: new Date(Date.now() + 86400000 * 3).toISOString(),
      durationHours: 2,
      addedBy: 'platform.ops@meetinghub.ai',
    },
  ],
};

export const featureFlags = Array.from({ length: 15 }, (_, i) => ({
  id: `ff-${i}`,
  key: `ff.platform.${['whatsapp_v2', 'ai_routing_v2', 'scim_beta', 'export_s3', 'mom_v3'][i % 5]}_${i}`,
  description: `Platform feature gate ${i + 1}`,
  environment: ['production', 'staging'][i % 2],
  scopeLabel: i % 4 === 0 ? 'All plans' : 'Starter, Growth',
  scope: {
    allPlans: i % 4 === 0,
    starter: true,
    growth: true,
    enterprise: i % 3 === 0,
    tenantIds: i % 5 === 0 ? ['tnt-1001'] : [],
  },
  enabled: i % 3 !== 0,
  dangerous: i % 7 === 0,
  owner: `platform${i % 4}@meetinghub.ai`,
  rolloutPct: (i * 7) % 100,
  updatedAt: new Date(Date.now() - i * 86400000).toISOString(),
}));

const MIN_RETENTION = {
  transcripts: 30,
  recordings: 14,
  audit_logs: 90,
  mom_documents: 30,
  webhook_payloads: 7,
  user_data: 30,
};

export const retentionMinimums = MIN_RETENTION;

export const storageRetentionMatrix = [
  {
    artifactType: 'Transcripts',
    key: 'transcripts',
    retentionDays: 365,
    archivePolicy: 'Auto-archive',
    purgeSchedule: 'Monthly',
    status: 'active',
  },
  {
    artifactType: 'Meeting Recordings',
    key: 'recordings',
    retentionDays: 180,
    archivePolicy: 'Auto-archive',
    purgeSchedule: 'Weekly',
    status: 'active',
  },
  {
    artifactType: 'Audit Logs',
    key: 'audit_logs',
    retentionDays: 400,
    archivePolicy: 'Manual',
    purgeSchedule: 'Manual',
    status: 'active',
  },
  {
    artifactType: 'MOM Documents',
    key: 'mom_documents',
    retentionDays: 365,
    archivePolicy: 'Auto-archive',
    purgeSchedule: 'Daily',
    status: 'active',
  },
  {
    artifactType: 'Webhook Payloads',
    key: 'webhook_payloads',
    retentionDays: 14,
    archivePolicy: 'Never',
    purgeSchedule: 'Daily',
    status: 'active',
  },
  {
    artifactType: 'User Data',
    key: 'user_data',
    retentionDays: 730,
    archivePolicy: 'Manual',
    purgeSchedule: 'Monthly',
    status: 'active',
  },
];

export const storageUsageByType = [
  { type: 'Transcripts', gb: 4200 },
  { type: 'Recordings', gb: 8900 },
  { type: 'Audit Logs', gb: 1200 },
  { type: 'MOM Documents', gb: 600 },
  { type: 'Webhook Payloads', gb: 300 },
  { type: 'User Data', gb: 2100 },
];

export const storageUsageTotals = { usedGb: 17300, limitGb: 25000 };
